<div class="column gap margin-top" [class.fade-left]="fadeLeft$ | async" [class.fade-left-reverse]="fadeLeftReverse$ | async"
     [class.fade-right]="fadeRight$ | async" [class.fade-right-reverse]="fadeRightReverse$ | async">

  <app-thematic-trains *ngIf="!loading" [trainsByThematics]="trainsByThematic" />
  <app-spinner *ngIf="loading" />
</div>
